import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import { MoreCaseStudies } from '../../../../components';

import { meta } from '../../index.js'

export default class fedex extends Component {
	render () {
		return (
			<React.Fragment>
				<Helmet
					title={meta.title.replace('blueshyft', 'FedEx')}
					meta={[
						{ name: 'description', content: meta.description },
						{ property: 'og:title', content: meta.title },
						{ property: 'og:url', content: meta.url },
						{ property: 'og:site_name', content: 'Blueshyft' },
						{ property: 'og:type', content: 'website' },
						{ property: 'og:image', content: meta.url + meta.image },
						{ property: 'og:description', content: meta.description },
						{ property: 'twitter:card', content: 'summary_large_image' },
						{ property: 'twitter:site', content: '@Blueshyft' },
						{ property: 'twitter:title', content: meta.title },
						{ property: 'twitter:description', content: meta.description },
						{ property: 'twitter:image', content: meta.url + meta.image },
					]}
				/>
				
				<section className="case-study">
					<div className="container">
						<div className="title">
							<a href="https://fedex.com.au" target="_blank"><img src="/images/new/logos/Fedex_Express_logo.png"/></a>
							<h3>The World on Time</h3>
							<p>FedEx Express is a multinational corporation that operates in over 220 countries and states worldwide. FedEx Express is renowned for facilitating delivery processes efficiently in order to satisfy its consumer’s needs to a high standard. With access to blueshyft’s national network of alternative delivery locations, FedEx will be able to solve the issue of customers not being at home and missing parcel deliveries.</p>
						</div>

						<div className="block">
							<h4>A coherent partnership (customer experience and operational efficiencies)</h4>
							<p>Customer experience is a prime focus for both FedEx Express and blueshyft. With parcels either being redirected to depots and re-delivered, or worse, customers having to go themselves, failed home deliveries are a major issue. This process creates high inefficiencies within the operational process.  A simple drop-off location that holds one’s parcel can satisfy customer demands as well as capitalising on opportunity costs; the cost of rerouting a parcel to a blueshyft enabled store is significantly less costly than taking it back to a depot.</p>
						</div>

						<div className="block">
							<h4>A simple platform for complex problems</h4>
							<p>An extensive network of over 1,400 stores nationwide and its proprietary technology platform has allowed blueshyft to gain the necessary experience to solve complex challenges put forward by its partners. A streamlined service that dedicates resources in the aim of encouraging convenience for its customers. Here’s the benefits:</p>
							<div className="features">
								<div className="feature">
										<img src="/images/new/icons/cross-blue.svg" />
										<p>Failed delivery</p>
								</div>
								<div className="feature">
										<img src="/images/new/icons/arrow-blue.svg" />
										<p>Direct delivery to retail locations</p>
								</div>
								<div className="feature">
										<img src="/images/new/icons/truck-blue.svg" />
										<p>Parcel tracking</p>
								</div>
								<div className="feature">
										<img src="/images/new/icons/returns-blue.svg" />
										<p>Easy parcel returns</p>
								</div>
								<div className="feature">
										<img src="/images/new/icons/cog-blue.svg" />
										<p>Complete API integration</p>
								</div>
							</div>
						</div>

						<div className="block">
							<h4>Delivering the right way, everyday</h4>
							<p>Parcel pick-ups and drop offs are a burden in everyone’s day. With blueshyft, FedEx Express customers now have the opportunity to pick up their missed deliveries when and how they want. These are the benefits:</p>
							<p>•  Collecting parcels from their local news and convenience store - If a customer is not home to accept their delivery, it can be rerouted to their nearest blueshyft enabled store</p>
							<p>•  Choosing their local news and convenience store for direct delivery - if customers do not want their parcel to be delivered to their home, they can send it directly to their nearest blueshyft enabled store for pickup</p>
							<p>•  Most stores open early till’ late, seven days a week - unlike depot locations and traditional postal outlets, blueshyft enabled stores have little to no waiting times upon arrival</p>
							<p>•  User-friendly application service - streamlining parcel pick ups is conducted through a consistent application that simplifies the operational process</p>
						</div>

						<div className="highlight">
							<p>Ultimately, customer convenience is paramount for both FedEx Express and blueshyft. With this partnership, failed home deliveries are no longer a complexity that burdens FedEx Express and its customers. Blueshyft’s technology platform and extensive network, has seen re-deliveries reduce substantially, significantly reducing overhead costs and time.</p>
						</div>
					</div>

				</section>

				<MoreCaseStudies cases={['lb', 'news', 'goget']} />

			</React.Fragment>
		);
	}
};


// WEBPACK FOOTER //
// ./client/scenes/Clients/scenes/fedex/index.js